import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Popover, Typography } from "@mui/material";
import { NOTE_KINDS } from "../wsProtocol";

const ICONS = { goals: "🎯", identity: "🏛️" };
const TITLES = { goals: "wb_lesson_goals", identity: "wb_identity_link" };

// Sits in the page header next to the lesson name: press it and the teacher's
// notes drop down, press it again and they are gone. Nothing opens on its own,
// so the board is never covered unless the student asks for it.
const LessonNotes = ({ notes }) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState(null);

  const shown = NOTE_KINDS.filter((kind) => notes && notes[kind] && notes[kind].text);
  if (!shown.length) return null;

  return (
    <>
      <IconButton
        size="small"
        title={t("wb_lesson_info")}
        onClick={(event) => setAnchor(anchor ? null : event.currentTarget)}
        sx={{
          fontSize: "1.05rem",
          background: anchor ? "#2f9e5c" : "#fff",
          boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
          "&:hover": { background: anchor ? "#2f9e5c" : "#eef3f7" },
        }}
      >
        📋
      </IconButton>

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: { borderRadius: "14px", marginTop: "6px" } } }}
      >
        <Box sx={{ width: "min(300px, 80vw)", maxHeight: "55vh", overflowY: "auto", padding: "12px 14px", textAlign: "start" }}>
          {shown.map((kind) => (
            <Box key={kind} sx={{ marginBottom: "12px", "&:last-of-type": { marginBottom: 0 } }}>
              <Typography fontSize="0.74rem" fontWeight={800} color="#2f7f52" mb={0.5}>
                {ICONS[kind]} {t(TITLES[kind])}
              </Typography>
              <Typography
                fontSize="0.86rem"
                fontWeight={600}
                sx={{ lineHeight: 1.6, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
              >
                {notes[kind].text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default LessonNotes;
